import animations from "create-keyframe-animation";
import BaseComponent from "../../baseComponent.js";
import DatasetCard from "./datasetCard.jsx";
import styles from "./datasets.scss";

export default class Datasets extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let $container = $(this.refs.container);
    $("#data-bank").scroll((e) => {
      let scrollTop;
        scrollTop = $("#data-bank").scrollTop();
        if (scrollTop + $("#data-bank").height() > $container.height()) {
          this.props.nextPage();
        }
      if (scrollTop === 0) {
        this.hideScrollTopBtn();
      } else if (scrollTop > 20) {
        this.showScrollTopBtn();
      }
    });

    this.onWindowResize();
    $("#data-bank").resize(() => this.onWindowResize());

    let options = {
      duration: 500,
      easing: 'ease-in-out'
    };

    animations.registerAnimation({
      name: "slideUp",
      animation: [{translate: [0, 0]}, {translate: [0, -80]}],
      presets: options
    });

    animations.registerAnimation({
      name: "slideDown",
      animation: [{translate: [0, -80]}, {translate: [0, 0]}],
      presets: options
    });
  }

  scrollToTop() {
    $("#data-bank").scrollTop(0);
  }

  showScrollTopBtn() {
    animations.runAnimation(this.refs.scrollBtn, 'slideUp');
  }

  hideScrollTopBtn() {
    animations.runAnimation(this.refs.scrollBtn, 'slideDown');
  }

  componentWillUnmount() {
    $("#data-bank").off("scroll");
    $("#data-bank").off('resize', this.onWindowResize);
  }

  componentDidUpdate() {
    this.onWindowResize();
  }

  onWindowResize() {
    let tileWidth = $(".flip").outerWidth(true);
    let numberOfColumns = parseInt($(this.refs.container).width() / tileWidth);
    $(this.refs.row).width(tileWidth * numberOfColumns);
  }

  render() {
    let datasetCards = this.props.datasets.map((dataset, index) => {
      return <DatasetCard key={index}
                          dataset={dataset}
                          onDetailClick={(dataset) => this.props.onDatasetDetailClick(dataset)}/>;
    });

    return (
      <div className={styles.datasets} ref="container">
        <div className={styles.datasetCards} ref="row">
          {datasetCards}
        </div>
        <a className={["btn-floating waves-effect waves-light white", styles.scrollTopBtn].join(" ")}
           ref="scrollBtn" onClick={(e) => this.scrollToTop(e)}>
          <i className="material-icons">arrow_drop_up</i>
        </a>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/data-bank/datasets/datasets.jsx